var _path, _rect, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveDishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9552 14.0007C22.0048 14.5508 21.555 15 21.0027 15C19.2648 15 15.4395 15 11 15C6.56049 15 2.73524 15 0.997284 15C0.444999 15 -0.00475504 14.5508 0.044776 14.0007C0.549655 8.39389 5.2617 4 11 4C16.7383 4 21.4503 8.39389 21.9552 14.0007Z",
    fill: "current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 22,
    height: 2,
    rx: 1,
    fill: "current"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2,
    r: 2,
    fill: "current"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14,
    r: 5.5,
    fill: "current",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.3125L19.0625 15.875L22.1875 12.75",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDishIcon);
export default __webpack_public_path__ + "static/media/ActiveDishIcon.f84e2efbab0fbe9f8c11762c906c22ff.svg";
export { ForwardRef as ReactComponent };